/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Person } from '../../gql-types.generated';
import { RootState } from '../../store';

interface SliceState {
  error?: Error;
  userList: Person[];
}

const initialState: SliceState = {
  error: undefined,
  userList: [],
};

export const slice = createSlice({
  name: 'apteanAdminUsers',
  initialState,
  reducers: {
    fetchError: (state, action: PayloadAction<Error>) => {
      state.error = action.payload;
    },
    fetchApteanAdminUsersSuccess: (state, action: PayloadAction<Person[]>) => {
      state.userList = action.payload;
    },
  },
});

export const selectApteanAdminUsers = (state: RootState): Person[] => state.apteanAdminUsers.userList;
export const selectApteanAdminUsersError = (state: RootState): Error | undefined => state.apteanAdminUsers.error;

export const { fetchError, fetchApteanAdminUsersSuccess } = slice.actions;

export default slice.reducer;
